var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { apihost, pushmsg, get_access_token, set_access_token, path2doctype, K5A } from "../utils";
const apiHost = apihost();
axios.interceptors.response.use(resp => resp, (err) => {
    var _a, _b, _c;
    if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        const url = (_c = (_b = err.config) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : '';
        if (!url.endsWith('/kb/abostat') && window.location.hash !== '') {
            pushmsg("unauthorized");
            window.location.hash = '';
        }
    }
    return Promise.reject(err);
});
const getAuthHeader = () => {
    var _a;
    // Check if access token is passed, in case of reload
    const url = new URL(window.location.href);
    if (url.searchParams.has('access_token')) {
        set_access_token((_a = url.searchParams.get('access_token')) !== null && _a !== void 0 ? _a : '');
        url.searchParams.delete('access_token');
        window.history.replaceState({}, document.title, url.toString());
    }
    const token = get_access_token();
    return {
        'X-Access-Token': get_access_token() || ''
    };
};
// cached holder + in-flight promise
let _cachedMostRecentYear = null;
let _mostRecentYearPromise = null;
export const download = (url) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const axiosConf = {
        headers: getAuthHeader(),
        responseType: 'blob'
    };
    try {
        const response = yield axios.get(url, axiosConf);
        const blob = response.data;
        const cd = ((_a = response.headers) === null || _a === void 0 ? void 0 : _a['content-disposition']) || ((_b = response.headers) === null || _b === void 0 ? void 0 : _b['Content-Disposition']) || '';
        let filename = '';
        const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i);
        if (m && m[1]) {
            filename = decodeURIComponent(m[1]);
        }
        else {
            try {
                filename = decodeURIComponent(url.split('/').pop() || 'download');
            }
            catch (_c) {
                filename = 'download';
            }
        }
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        a.rel = 'noopener';
        document.body.appendChild(a);
        // Prevent Kilkaya from messing around with the blob link
        const stopPropagation = (e) => e.stopPropagation();
        a.addEventListener('click', stopPropagation);
        a.addEventListener('mousedown', stopPropagation);
        a.addEventListener('mouseup', (e) => stopPropagation);
        a.click();
        a.removeEventListener('click', stopPropagation);
        a.removeEventListener('mousedown', stopPropagation);
        a.removeEventListener('mouseup', stopPropagation);
        a.remove();
        URL.revokeObjectURL(blobUrl);
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 5000);
        K5A.download(url, { docType: path2doctype(filename) });
    }
    catch (wtf) {
        return Promise.reject(wtf);
    }
});
export const mostRecentYear = () => __awaiter(void 0, void 0, void 0, function* () {
    if (_cachedMostRecentYear !== null) {
        return _cachedMostRecentYear;
    }
    _mostRecentYearPromise = axios
        .get(`${apiHost}/kb/info`)
        .then((res) => {
        var _a, _b, _c, _d;
        if ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nyeste_aar) {
            _cachedMostRecentYear = (_d = (_c = res.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.nyeste_aar;
        }
        _mostRecentYearPromise = null;
        return _cachedMostRecentYear;
    });
    return _mostRecentYearPromise;
});
export const fetchApiText = (knr, topic) => {
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        if (/^\d{4}$/.test(knr !== null && knr !== void 0 ? knr : '')) {
            const url = `${apiHost}/kb/kommuner/${knr}/analysetekster${topic ? `/${topic}` : ``}`;
            axios.get(url, axiosConf)
                .then((r) => {
                var _a;
                resolve((_a = r.data.data) === null || _a === void 0 ? void 0 : _a.tekster);
            })
                .catch((e) => {
                reject(e);
            });
        }
        else {
            resolve({});
        }
    });
};
export const fetchCodeList = () => {
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        const url = `${apiHost}/kb/kodeliste`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve(r.data.data);
        })
            .catch((e) => {
            reject(e);
        });
    });
};
export const fetchDatabaseInfo = () => {
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        const url = `${apiHost}/kb/info`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve(r.data.data);
        })
            .catch((e) => {
            reject(e);
        });
    });
};
export const fetchFileArchiveSet = (knr, year, mostRecent) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (mostRecent) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
        if (year) {
            year++; // Report year is 1 ahead of data year
        }
    }
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        if (/^\d{4}$/.test(knr !== null && knr !== void 0 ? knr : '') === true) {
            const url = `${apiHost}/kb/filarkiv/${knr}${year ? `/${year}` : ''}`;
            axios.get(url, axiosConf)
                .then((r) => {
                resolve(r.data.data);
            })
                .catch((e) => {
                reject(e);
            });
        }
        else {
            resolve({});
        }
    });
});
export const fetchMunicipalityInfo = (knr, year) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!year) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
    }
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        if (!knr) {
            return reject(new Error('Missing knr'));
        }
        const url = `${apiHost}/kb/kommuner/${year}/${knr}`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve(r.data.data);
        })
            .catch((e) => {
            reject(e);
        });
    });
});
export const fetchMunicipalityAnalytics = (knr, year) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!year) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
    }
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        if (!knr) {
            return reject(new Error('Missing knr'));
        }
        const url = `${apiHost}/kb/kommuner/sektorresultater/${knr}/${year}/analysetekster`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve(r.data.data);
        })
            .catch((e) => {
            reject(e);
        });
    });
});
export const fetchMunicipalityList = (year) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!year) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
    }
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        const url = `${apiHost}/kb/kommuner/${year}`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve(r.data.data);
        })
            .catch((e) => {
            reject(e);
        });
    });
});
export const fetchMunicipalitySectorResults = (knr, sec, year) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!year) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : undefined;
    }
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        if (!knr) {
            return reject(new Error('Missing knr'));
        }
        const url = year
            ? sec ? `${apiHost}/kb/kommuner/sektorresultater/${knr}/${year}/${sec}`
                : `${apiHost}/kb/kommuner/sektorresultater/${knr}/${year}`
            : `${apiHost}/kb/kommuner/sektorresultater/${knr}`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve((sec ? { [sec]: r.data.data }
                : r.data.data));
        })
            .catch((e) => {
            reject(e);
        });
    });
});
export const fetchMunicipalityTotalResult = (knr, year) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (year === undefined) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
    }
    const authHdr = getAuthHeader();
    const axiosConf = { headers: authHdr };
    return new Promise((resolve, reject) => {
        const url = `${apiHost}/kb/totalrangering/${year}/${knr}`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve(r.data.data);
        })
            .catch((e) => {
            reject(e);
        });
    });
});
export const fetchProductCoupon = (productId) => {
    return new Promise((resolve, reject) => {
        const url = `${apiHost}/kb/produkt/${productId}`;
        axios.get(url)
            .then((r) => {
            resolve(r.data.produkt);
        })
            .catch((e) => {
            reject(e);
        });
    });
};
export const fetchSubscriberStatus = () => {
    return new Promise((resolve) => {
        const authHdr = getAuthHeader();
        const axiosConf = { headers: authHdr };
        const url = `${apiHost}/kb/abostat`;
        axios.get(url, axiosConf)
            .then((r) => {
            resolve({ isLoggedIn: !!authHdr['X-Access-Token'], isEligible: true });
        })
            .catch((e) => {
            resolve({ isLoggedIn: !!authHdr['X-Access-Token'], isEligible: false });
        });
    });
};
export const fetchTotalRanking = (year) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (year === undefined) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
    }
    return new Promise((resolve) => {
        const authHdr = getAuthHeader();
        const axiosConf = { headers: authHdr };
        const url = `${apiHost}/kb/totalrangering`;
        axios.get(url, axiosConf)
            .then((r) => {
            var _a;
            const mostRecentYear = Math.max(...(Object.keys(r.data.data).map(s => parseInt(s)))).toString();
            const rankingData = {
                http_status: 200,
                user_logged_in: !!authHdr['X-Access-Token'],
                ranking: Object.values(r.data.data[year !== null && year !== void 0 ? year : mostRecentYear])
            };
            resolve(Object.assign(Object.assign({}, rankingData), { http_status: (_a = r.status) !== null && _a !== void 0 ? _a : null }));
        })
            .catch((e) => {
            resolve({ http_status: 401, user_logged_in: !!authHdr['X-Access-Token'] });
        });
    });
});
export const fetchSectorRanking = (year, sectorCode) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (year === undefined) {
        year = (_a = yield mostRecentYear()) !== null && _a !== void 0 ? _a : null;
    }
    return new Promise((resolve) => {
        const authHdr = getAuthHeader();
        const axiosConf = { headers: authHdr };
        const url = `${apiHost}/kb/sektorrangering/${year}${sectorCode ? `/${sectorCode}` : ``}`;
        axios.get(url, axiosConf)
            .then((r) => {
            var _a;
            const rankingData = {
                http_status: 200,
                user_logged_in: !!authHdr['X-Access-Token'],
                ranking: r.data.data
            };
            resolve(Object.assign(Object.assign({}, rankingData), { http_status: (_a = r.status) !== null && _a !== void 0 ? _a : null }));
        })
            .catch((e) => {
            resolve({ http_status: 401, user_logged_in: !!authHdr['X-Access-Token'] });
        });
    });
});
